/// <amd-module name="Search/Wiki/Flux/Sources/WikiSearchSource" />

import * as Rest_Client from "Search/WebApi/RestClient/Search";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPageService } from "VSS/Platform/Page";
import { IProjectData } from "Tfs/Platform/Page";
import { WikiSearchResponse, WikiSearchRequest } from "Search/WebApi/Contracts/Search.Shared";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { getTimestamp } from "Search/Shared/Base/Telemetry";
import { SearchSourceType } from "Search/Shared/Base/ActionsHub2";

const WIKI_SEARCH_PAGE_DATAPROVIDER_CONTRIBUTION_ID = "ms.vss-wiki-search.wiki-search-page-viewmodel-data-provider";
const WIKI_SEARCH_ONPREM_PAGE_DATAPROVIDER_CONTRIBUTION_ID = "ms.vss-wiki-searchonprem.wiki-search-page-viewmodel-data-provider";

export interface ISearchSourceResponse {
    response: WikiSearchResponse;

    source: SearchSourceType;
}

export class WikiSearchSource {
    private readonly wikiSearchRestClient: Rest_Client.ISearchRestClient;
    private useDataProvider: boolean;

    constructor(
        isTabSwtich: boolean,
        private readonly pageContext: IVssPageContext,
        private readonly project: IProjectData | undefined) {
        this.wikiSearchRestClient = this.pageContext.getRestClient<Rest_Client.ISearchRestClient>("ISearchRestClient");
        this.useDataProvider = !isTabSwtich;
    }

    public getWikiSearchResults(
        query: WikiSearchRequest,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error }: any) => void): void {
        if (this.useDataProvider) {
            const pageService = this.pageContext.getService<IVssPageService>("IVssPageService");
            const pageData = pageService.getData();
            const dataProviderContributionId = pageData!.isHosted
                ? WIKI_SEARCH_PAGE_DATAPROVIDER_CONTRIBUTION_ID
                : WIKI_SEARCH_ONPREM_PAGE_DATAPROVIDER_CONTRIBUTION_ID;

            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            const startTime = getTimestamp();

            const response: WikiSearchResponse | undefined = contributionService.getData(dataProviderContributionId);
            this.useDataProvider = false;

            const telemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
            telemetryService.publishEvent(
                "search.V2Page",
                "WikiSearchWebPageDataServiceResolution",
                {
                    E2ETimeInMs: getTimestamp() - startTime
                });

            if (response) {
                onSuccess({ response, source: SearchSourceType.DataProvider });
                return;
            }
        }

        this.wikiSearchRestClient
            .fetchWikiSearchResults(query, this.project && this.project.id)
            .then(response => {
                onSuccess({ response, source: SearchSourceType.RestApi });
            }, error => {
                onFailure({ error });
            });
    }
}
